<script>
    import Piece from './Piece.svelte';
    import { db } from './firebase';
    import { collection, query, orderBy, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';
    import { collectionData } from 'rxfire/firestore';
    import { startWith } from 'rxjs/operators';

    export let uid;

    let text = '';
    const collectionRef = collection(db, 'tasks');
    const q = query(collectionRef, orderBy('created'))
    const groceries = collectionData(q, { idField: 'id' }).pipe(startWith([]));

    function add() {
        if (!text) return;
        addDoc(collection(db, 'tasks'), { uid, text, complete: false, created: Date.now() });
        text = '';
    }

    function updateStatus(event) {
        const { id, newStatus } = event.detail;
        updateDoc(doc(db, 'tasks', id), {complete: newStatus})
    }

    function removeItem(event) {
        const { id } = event.detail;
        deleteDoc(doc(db, 'tasks', id));
    }
</script>

<style>
    input { display: block }
    .add {
        position: sticky;
        top: 20px;
        z-index: 2;
        display: grid;
        grid-auto-flow: column;
        grid-template-columns: 1fr 60px;
        margin: 0 25px;
        box-shadow: 0 5px 15px 10px #121212;
        background: #222228;
        border-radius: 8px;
        margin-bottom: 20px;
    }
    .add-input {
        border: none;
        outline: none;
        padding: .8em 1em;
        width: calc(100% - 40px);
        font-size: 1.2em;
        font-weight: 300;
        background: none;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    ::placeholder {
        color: #767676;
    }
    .add button {
        position: relative;
        height: 100%;
        width: 70px;
        font-size: 25px;
        border: none;
        outline: none;
    }
    .add button svg {
        display: block;
        position: relative;
        fill: #fd754a;
        width: 53px;
        z-index: 1;
    }
    .add button:after {
        content: '';
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        left: 6px;
        top: 7px;
        box-shadow: 0 3px 10px 0 #121212;
    }
</style>

<form on:submit|preventDefault={add} class="add">
    <input bind:value={text} placeholder="Was brauchen wir?" class="add-input" required>
    <button>
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50,11A39,39,0,1,0,89,50,39.05,39.05,0,0,0,50,11ZM62.73,53H53v9.73a3,3,0,0,1-6,0V53H37.27a3,3,0,0,1,0-6H47V37.27a3,3,0,0,1,6,0V47h9.73a3,3,0,1,1,0,6Z"/></svg>
    </button>
</form>

<ul>
    {#each $groceries as piece}
        <Piece {...piece} on:remove={removeItem} on:toggle={updateStatus} />
    {/each}
</ul>